const prefix = 'component_select_media/'

const type = {
    LOAD_LIST_MEDIA: prefix + 'load_list_media',
    LOAD_LIST_MEDIA_SUCCESS: prefix + 'load_list_media_success',
    SET_DEFAULT_CURRENT_MEDIA: prefix + 'set_default_current_media',
    UPDATE_CURRENT_MEDIA: prefix + 'update_current_media',
    SAVE_CURRENT_MEDIA: prefix + 'save_current_media',
    DELETE_MEDIA: prefix + 'delete_media',
    UPDATE_STATE: prefix + 'update_state',
    UPDATE_FILE: prefix + 'update_file',

    CHANGE_PAGE_SIZE: prefix + 'change_page_size',
    CHANGE_CURRENT_PAGE: prefix + 'change_current_page',

    SHOW_MODAL_CURRENT_MEDIA_INFO: prefix + 'show_modal_current_media_info',
    DISMISS_MODAL_CURRENT_MEDIA_INFO:
        prefix + 'dismiss_modal_current_media_info',
    SHOW_MODAL_CONFIRM_DELETE_MEDIA: prefix + 'show_modal_confirm_delete_media',
    DISMISS_MODAL_CONFIRM_DELETE_MEDIA:
        prefix + 'dismiss_modal_confirm_delete_media',

    UPDATE_SELECT_STATE_MEDIA: prefix + 'update_select_state_media',
    UPDATE_SELECTED_MEDIAS: prefix + 'update_selected_medias',

    UPDATE_TEXT_SEARCH: prefix + 'update_text_search',
    SEARCH_MEDIA: prefix + 'search_media',
}

const action = {
    loadListMedias: params => {
        return {
            type: type.LOAD_LIST_MEDIA,
            payload: {
                params,
            },
        }
    },
    loadListMediasSuccess: medias => {
        return {
            type: type.LOAD_LIST_MEDIA_SUCCESS,
            payload: {
                medias,
            },
        }
    },
    setDefaultCurrentMedia: () => {
        return {
            type: type.SET_DEFAULT_CURRENT_MEDIA,
            payload: {},
        }
    },
    updateCurrentMedia: media => {
        return {
            type: type.UPDATE_CURRENT_MEDIA,
            payload: {
                media,
            },
        }
    },
    saveCurrentMedia: () => {
        return {
            type: type.SAVE_CURRENT_MEDIA,
            payload: {},
        }
    },
    deleteMedia: mediaId => {
        return {
            type: type.DELETE_MEDIA,
            payload: {
                mediaId,
            },
        }
    },
    updateState: state => {
        return {
            type: type.UPDATE_STATE,
            payload: {
                state,
            },
        }
    },
    updateFile: file => {
        return {
            type: type.UPDATE_FILE,
            payload: {
                file,
            },
        }
    },
    changePageSize: pageSize => {
        return {
            type: type.CHANGE_PAGE_SIZE,
            payload: {
                pageSize,
            },
        }
    },
    changeCurrentPage: pageIndex => {
        return {
            type: type.CHANGE_CURRENT_PAGE,
            payload: {
                pageIndex,
            },
        }
    },
    showModalCurrentMediaInfo: () => {
        return {
            type: type.SHOW_MODAL_CURRENT_MEDIA_INFO,
            payload: {},
        }
    },
    dismissModalCurrentMediaInfo: () => {
        return {
            type: type.DISMISS_MODAL_CURRENT_MEDIA_INFO,
            payload: {},
        }
    },
    showModalConfirmDeleteMedia: () => {
        return {
            type: type.SHOW_MODAL_CONFIRM_DELETE_MEDIA,
            payload: {},
        }
    },
    dismissModalConfirmDeleteMedia: () => {
        return {
            type: type.DISMISS_MODAL_CONFIRM_DELETE_MEDIA,
            payload: {},
        }
    },
    updateSelectMediaState: (mid, selectState) => {
        return {
            type: type.UPDATE_SELECT_STATE_MEDIA,
            payload: {
                mid,
                selectState,
            },
        }
    },
    updateSelectedMedias: medias => {
        return {
            type: type.UPDATE_SELECTED_MEDIAS,
            payload: {
                medias,
            },
        }
    },
    updateTextSearch: textSearch => {
        return {
            type: type.UPDATE_TEXT_SEARCH,
            payload: {
                textSearch,
            },
        }
    },
    searchMedia: () => {
        return {
            type: type.SEARCH_MEDIA,
            payload: {},
        }
    },
}

export default {
    type,
    action,
}
